import { render } from "./Programa.vue?vue&type=template&id=88f86980"
import script from "./Programa.vue?vue&type=script&lang=js"
export * from "./Programa.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__